<template>
    <div v-if="!paymentOnly && !printOnly" class="detail_body posi_rela cashier-order-detail">
        <div class="loading_bd flex_c" v-if="detailLoading">
            <div class="loading_con flex_c">
                <el-icon class="loading_size is-loading">
                    <Loading/>
                </el-icon>
                <div class="loading_text">数据加载中</div>
            </div>
        </div>
        <div class="patient_info_body">
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font font1_2rem flex_c_left">
                        <span class="no_font">NO.</span><span class="no_num_font">{{ medicalOrder.serialNo }}</span>
                    </div>
                    <div class="detail_font status_font flex_c_right">
                            <span :class="medicalOrder.status === '1' || medicalOrder.status === '6' ? 'text-blue':
                            medicalOrder.status === '2' || medicalOrder.status === '5' ? 'text-orange':
                            medicalOrder.status === '3' || medicalOrder.status === '4' ? 'text-red':'text-grey1'">{{
                                    getOrderStatus(medicalOrder.status)
                                }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font flex_c_left">
                        <span class="mrr20"><span class="font_gray">姓名：</span>{{ patientInfo.name }}</span>
                        <span class="mrr20"><span
                            class="font_gray">性别：</span>{{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }}</span>
                        <span class="mrr20"><span
                            class="font_gray">年龄：</span>{{ patientInfo.age === null ? '--' : patientInfo.age }}岁</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">身份证号码：</span>{{patientInfo.identity ? patientInfo.identity.substr(0,6) + '********' + patientInfo.identity.substr(14, 20) : '--'}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">联系地址：</span>{{ patientInfo.province === null ? '无' : patientInfo.province }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font flex_c_left">
                        <span
                            class="font_gray">临床诊断：</span>{{ medicalOrder.clinicalDiagnosis === null ? '无' : medicalOrder.clinicalDiagnosis }}
                    </div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">RP：
                        <span
                            class="font_gold">{{
                                medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : medicalOrder.billingType === '3' ? '水丸' : '颗粒'
                            }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="med_list_con flex_left_warp">
                        <div class="med_list_li flex_c_between" v-for="(item, index) in medicalOrder.orderMedicineList"
                             :key="index">
                            <span class="font_gold"
                                  v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && (medicalOrder.billingType === '0' || medicalOrder.billingType === 0) && newRuleOpen">[{{
                                    item.standard
                                }}]</span>
                            <span class="med_li_name">{{ item.meName }}</span>
                            <span class="font_gold"
                                  v-if="item.drugProperty && item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{
                                    item.drugProperty
                                }})</span>
                            <span class="font_gray"
                                  v-if="item.decoctionId && item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && (medicalOrder.billingType !== '0' && medicalOrder.billingType !== 0) && item.decoctionName !== '无'">({{
                                    item.decoctionName
                                }})</span>
                            <span class="font_gray mrl10">{{ item.newGCount }}g</span>
                        </div>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col"
                     v-if="medicalOrder.billingType === '2' && medicalOrder.orderMedicineFuList.length > 0">
                    <div class="detail_font flex_c_left">辅料：</div>
                    <div class="font_black">{{ showOrderMedicineFuList }}</div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font flex_c_left">每剂 {{ medicalOrder.orderMedicineList.length }} 味药材，共
                        {{ medicalOrder.viceNum }} 剂
                    </div>
                    <div class="detail_font flex_c_left">
<!--                        <span class="font_gray">药方总重：</span>-->
<!--                        <span-->
<!--                            class="detail_font_red">{{ medicalOrder.orderWeight === null ? '0' : parseFloat(medicalOrder.orderWeight).toFixed(2) }}g</span>-->
                    </div>
                </div>
                <div class="detail_info_line flex_t_col">
                    <div class="detail_font flex_c_top">
                        <div class="f_left font_gray">用法：</div>
                        <div class="f_right">{{ medicalOrder.instructions }}</div>
                    </div>
                    <div class="detail_font flex_c_left"><span
                        class="font_gray">*每次服用袋数请参照随药寄送的贴纸说明</span></div>
                </div>
            </div>
            <!-- 其他信息-->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">其他信息：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap">
                    <div class="detail_font50 flex_c_left"><span class="font_gray">开方剂型：</span>
                        {{
                            medicalOrder.billingType === null || medicalOrder.billingType === '0' ? '颗粒' : medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : '水丸'
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">开方时间：</span>{{
                            medicalOrder.createTime === null ? "---" : medicalOrder.createTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">接单时间：</span>{{
                            medicalOrder.receiveTime === null ? "---" : medicalOrder.receiveTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '5'"><span
                        class="font_gray">驳回时间：</span>{{
                            medicalOrder.rejectTime === null ? "---" : medicalOrder.rejectTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">支付时间：</span>{{
                            medicalOrder.payTime === null ? "---" : medicalOrder.payTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">发货时间：</span>{{
                            medicalOrder.deliverTime === null ? "---" : medicalOrder.deliverTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '7'">
                            <span
                                class="font_gray">收货时间：</span>{{
                            medicalOrder.completeTime === null ? "---" : medicalOrder.completeTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '8'">
                            <span
                                class="font_gray">取消时间：</span>{{
                            medicalOrder.cancelTime === null ? "---" : medicalOrder.cancelTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"><span
                        class="font_gray">开方备注：</span>{{
                            medicalOrder.remark === '' || medicalOrder.remark === null ? '无' : medicalOrder.remark
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div class="patient_order_detail">
            <div class="detail_info_line flex_c_between">
                <div class="width100 name_font">总费用：<span
                    class="detail_font_red">{{ formatCashierAmount(medicalOrder.orderPrice) }}</span><span class="font_gold">元</span>
                </div>
                <div class="flex_c_right">
                    <el-button type="success" v-if="medicalOrder.status === '3'" @click="openPayScreen()"><el-icon aria-hidden="true"><Wallet /></el-icon><span>收费</span></el-button>
                    <el-button :loading="receiptLoading" v-if="medicalOrder.payTime" @click="previewPaymentReceipt"><el-icon v-if="!receiptLoading" aria-hidden="true"><View /></el-icon><span>预览凭证</span></el-button>
                    <el-button type="success" :loading="receiptLoading || receiptChecking" v-if="medicalOrder.payTime || medicalOrder.status === '3'" @click="printPaymentReceipt"><el-icon v-if="!receiptLoading && !receiptChecking" aria-hidden="true"><Printer /></el-icon><span>打印凭证</span></el-button>
                </div>
            </div>
        </div>
    </div>


    <!-- 订单收费 -->
    <el-dialog
        v-model="orderPayDialogVisible"
        :before-close="cancalPay"
        :show-close="!payDialogLocked"
        :close-on-click-modal="!payDialogLocked"
        :close-on-press-escape="!payDialogLocked"
        title="订单收费"
        class="cashier-payment-dialog"
        width="min(860px, calc(100vw - 32px))"
        align-center
    >
        <div class="pay_content flex_c_col">
            <!-- 同批说明统一置顶，收费前、扫码中及支付结果共用，空批次由子组件隐藏。 -->
            <PrescriptionGroupNotice :order-id="orderId" :visible="orderPayDialogVisible" :disabled="payDialogLocked || isWaitPayLoading" :refresh-key="`${payState}:${medicalOrder.payTime || ''}`" />
            <div class="cashier-payment-notice" role="note">
                <div><strong>本次收费：</strong>仅收取当前<span v-if="medicalOrder.serialNo"> {{ medicalOrder.serialNo }} </span>药方订单的费用，其他处方请逐张核对、分别办理。</div>
                <div v-if="needsIdentityBinding"><strong>身份核对：</strong>小程序订单请先核对患者身份并关联身份证，再开始收费。</div>
                <div><strong>付款核对：</strong>已付款订单请勿重复收费；患者表示已付款但系统未同步时，请先核对实际到账和收款记录，再继续办理。</div>
            </div>
            <div class="pay_main_body flex_t_col">
                <!--等待扫码-->
                <div class="pay_screen_con flex_c_col" v-if="isWaitPayLoading && !payLoading && !isPayed" role="status" aria-live="polite">
                    <div class="cashier-wait-panel">
                        <!-- 操作示意：手持显示微信付款码的手机靠近收钱吧盒子；条码为不可支付的装饰图案。 -->
                        <div class="cashier-scan-animation" aria-hidden="true">
                            <div class="cashier-scan-device">
                                <div class="cashier-scan-device-window"></div>
                                <span class="cashier-scan-device-name">收钱吧</span>
                            </div>
                            <div class="cashier-scan-beam"></div>
                            <div class="cashier-phone-hand">
                                <div class="cashier-hand"></div>
                                <div class="cashier-phone">
                                    <div class="cashier-phone-screen">
                                        <span class="cashier-phone-app">微信</span>
                                        <span class="cashier-phone-label">付款码</span>
                                        <div class="cashier-phone-code"></div>
                                    </div>
                                </div>
                                <div class="cashier-hand-thumb"></div>
                            </div>
                        </div>
                        <div class="cashier-wait-title">请扫描患者付款码</div>
                        <div class="cashier-wait-description">请患者打开微信或支付宝付款码，使用收钱吧盒子扫描。</div>
                        <div class="cashier-wait-note">扫码后将自动确认支付结果，请勿重复扫码或重复收费。</div>
                    </div>
                </div>
                <!--加载圈-->
                <div class="pay_loading_con flex_c_col" v-if="payLoading && !isPayed" role="status" aria-live="polite" aria-busy="true">
                    <div class="cashier-wait-panel">
                        <el-icon class="cashier-wait-icon is-loading"><Loading /></el-icon>
                        <div class="cashier-wait-title">{{ paymentMethod === 'SQB' ? '正在确认支付结果' : '正在确认缴费' }}</div>
                        <div class="cashier-wait-description">{{ paymentMethod === 'SQB' ? '付款码已提交，正在查询收款结果，请耐心等待。' : '正在登记本次收款，请稍候。' }}</div>
                        <div class="cashier-wait-note">{{ payDialogLocked ? '请勿关闭弹窗、重复扫码或再次收费，确认结果后会自动更新。' : '请勿重复操作，系统确认后将自动更新。' }}</div>
                    </div>
                </div>
                <!-- 订单信息-->
                <div class="pay_order_main cashier-entry" v-if="!isPayed">
                    <section class="cashier-block" aria-label="核对患者与处方">
                    <!-- 患者摘要不设总标题，各字段在独立信息块内上标下值展示。 -->
                    <!-- 身份核对说明统一放入顶部公共提示，患者区仅保留关联操作。 -->
                <div class="pay_info_item flex_c_between">
                    <div class="pay_info_item_left">患者信息：</div>
                    <div class="pay_info_item_right cashier-patient-summary">
                        <strong class="cashier-patient-name">{{ patientInfo.name }}</strong>
                        <span>{{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }}</span>
                        <span>{{ patientInfo.age === null ? '--' : patientInfo.age }}岁</span>
                    </div>
                </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">药方单号：</div>
                        <div class="pay_info_item_right">{{ medicalOrder.serialNo }}</div>
                    </div>
                    <div class="pay_info_item mini_identity_row" :class="{'mini_identity_row_bound': !needsIdentityBinding || miniIdentitySaved}">
                        <div class="pay_info_item_left">身份证号：
                            <!-- 核准说明统一在标题后展示，避免输入区重复提示。 -->
                            <span v-if="needsIdentityBinding" class="mini_identity_consistent" aria-live="polite">
                                <template v-if="miniIdentityLoading">正在核对身份证信息...</template>
                                <template v-else-if="miniIdentityError">{{ miniIdentityError }} <el-button link type="primary" @click="loadMiniOrderIdentityOptions">重试</el-button></template>
                                <template v-else-if="miniIdentitySaved">身份证已保存，可继续缴费</template>
                                <template v-else-if="miniIdentityQueryCompleted && miniIdentityReview && miniIdentityReview.identityConsistentAndValid">订单与患者档案身份证核对一致，格式正确</template>
                                <template v-else-if="miniIdentityQueryCompleted && miniIdentityReview && !miniIdentityReview.orderIdentity && !miniIdentityReview.profileIdentity">订单与患者档案均未填写身份证，请对照证件选择预约信息或按证件录入。</template>
                                <template v-else-if="miniIdentityQueryCompleted">请对照患者证件核准身份证；保存仅更新当前订单信息。</template>
                            </span>
                        </div>
                        <div class="pay_info_item_right mini_identity_value" v-if="!needsIdentityBinding || miniIdentitySaved">
                            <span>{{ (needsIdentityBinding ? medicalOrder.patientIdentity : patientInfo.identity) ? (needsIdentityBinding ? medicalOrder.patientIdentity : patientInfo.identity).substr(0, 6) + '********' + (needsIdentityBinding ? medicalOrder.patientIdentity : patientInfo.identity).substr(14, 20) : '--' }}</span>

                        </div>
                        <div class="pay_info_item_right mini_identity_binding" v-if="needsIdentityBinding && !miniIdentitySaved" v-loading="miniIdentityLoading" element-loading-text="查询中...">
                        <div class="mini_identity_controls">
                            <el-select v-if="selectedMiniIdentity !== 'manual' && (miniIdentityOptions.length || (miniIdentityReview && (miniIdentityReview.orderIdentityValid || miniIdentityReview.profileIdentityValid)))" :model-value="selectedMiniIdentity" :loading="miniIdentityLoading" :disabled="miniIdentityLoading || miniIdentitySaving || isWaitPayLoading" placeholder="请选择拟采用的身份证" @change="selectedMiniIdentity = $event; miniIdentitySaved = false" class="mini_identity_select">
                                <el-option v-if="miniIdentityReview && miniIdentityReview.identityConsistentAndValid" :label="miniIdentityReview.orderIdentity + '（当前已核验）'" value="current" />
                                <el-option v-if="miniIdentityReview && !miniIdentityReview.identityConsistentAndValid && miniIdentityReview.orderIdentityValid" :label="miniIdentityReview.orderIdentity + '（订单原身份证）'" value="order" />
                                <el-option v-if="miniIdentityReview && !miniIdentityReview.identityConsistentAndValid && miniIdentityReview.profileIdentityValid && miniIdentityReview.profileIdentity !== miniIdentityReview.orderIdentity" :label="miniIdentityReview.profileIdentity + '（患者档案）'" value="profile" />
                                <el-option v-for="reservation in miniIdentityOptions" :key="reservation.reId" :label="reservation.cardIdentity + '（预约信息，需对照证件）'" :value="reservation.reId" />
                            </el-select>
                            <el-input v-if="selectedMiniIdentity === 'manual' && miniIdentityQueryCompleted && !miniIdentityError && miniIdentityReview && !miniIdentityReview.identityConsistentAndValid" v-model="manualMiniIdentity" @input="selectedMiniIdentity = 'manual'; miniIdentitySaved = false" class="mini_identity_select" placeholder="请输入患者身份证号码" maxlength="18" :disabled="miniIdentityLoading || miniIdentitySaving || isWaitPayLoading" @keyup.enter="confirmMiniPatientIdentity" />
                            <el-button v-if="miniIdentityQueryCompleted && !miniIdentityError && miniIdentityReview && !miniIdentityReview.identityConsistentAndValid && selectedMiniIdentity !== 'manual'" link type="primary" :disabled="miniIdentityLoading || miniIdentitySaving || isWaitPayLoading" @click="selectedMiniIdentity = 'manual'; manualMiniIdentity = ''; miniIdentitySaved = false">按证件录入</el-button>
                            <el-button v-if="selectedMiniIdentity === 'manual' && (miniIdentityOptions.length || (miniIdentityReview && (miniIdentityReview.orderIdentityValid || miniIdentityReview.profileIdentityValid)))" link type="primary" :disabled="miniIdentityLoading || miniIdentitySaving || isWaitPayLoading" @click="selectedMiniIdentity = ''; manualMiniIdentity = ''; miniIdentitySaved = false">返回选择</el-button>
                            <el-button type="primary" :loading="miniIdentitySaving" :disabled="miniIdentitySaved || miniIdentityLoading || !miniIdentityQueryCompleted || !!miniIdentityError || !selectedMiniIdentity || isWaitPayLoading" @click="confirmMiniPatientIdentity">{{ miniIdentitySaved ? '已关联' : '保存确定' }}</el-button>
                        </div>

                        <div v-if="miniIdentityReview && !miniIdentityReview.identityConsistentAndValid && !miniIdentityLoading && !miniIdentityError" class="mini_identity_comparison" role="status">
                            <div class="mini_identity_comparison_row"><span>信息来源</span><span>身份证号码</span><span>后端校验</span></div>
                            <!-- 原号码保留供证件核对；未填写与已有但无效分别提示，保存前不视为已核准。 -->
                            <div class="mini_identity_comparison_row"><span>订单原信息</span><strong>{{ miniIdentityReview.orderIdentity || '未填写' }}</strong><span :class="{'mini_identity_invalid': miniIdentityReview.orderIdentity && !miniIdentityReview.orderIdentityValid}">{{ !miniIdentityReview.orderIdentity ? '未填写' : miniIdentityReview.orderIdentityValid ? '格式正确' : '格式无效' }}</span></div>
                            <div class="mini_identity_comparison_row"><span>患者档案</span><strong>{{ miniIdentityReview.profileIdentity || '未填写' }}</strong><span :class="{'mini_identity_invalid': miniIdentityReview.profileIdentity && !miniIdentityReview.profileIdentityValid}">{{ !miniIdentityReview.profileIdentity ? '未填写' : miniIdentityReview.profileIdentityValid ? '格式正确' : '格式无效' }}</span></div>
                            <div class="mini_identity_comparison_row mini_identity_selected"><span>本次拟采用</span><strong>{{ miniIdentityProposed() || (selectedMiniIdentity === 'manual' ? '请按患者证件录入' : '请对照患者证件选择或录入') }}</strong><span>{{ miniIdentitySourceLabel() }}</span></div>

                        </div>
                        </div>
                    </div>
                    </section>
                    <section class="cashier-block cashier-fee-block" aria-label="核对本单费用">
                        <div class="pay_info_title">核对本单费用<span class="cashier-section-hint">仅收当前药方</span></div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">医生诊金（元）</div>
                            <div class="pay_info_item_right">{{ formatCashierAmount(medicalOrder.docPrice) }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">加工费用（元）</div>
                            <div class="pay_info_item_right">{{ formatCashierAmount(medicalOrder.processingCosts) }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between cashier-amount-row">
                            <div class="pay_info_item_left">订单实付（元）</div>
                            <div class="pay_info_item_right font_weight font_28">{{ formatCashierAmount(medicalOrder.orderPrice) }}</div>
                        </div>
                    </section>
                    <div class="pay_method_section cashier-block">
                        <div class="pay_info_title">选择方式并缴费<span class="cashier-section-hint">核对金额 → 选择方式 → 确定缴费</span></div>
                        <el-radio-group v-model="paymentMethod" class="pay_method_options" :disabled="payDialogLocked || isWaitPayLoading || manualPaymentUncertain" aria-label="支付方式">
                            <el-radio label="SQB" class="pay_method_card">
                                <span class="pay_method_card_content">
                                    <svg class="pay_method_icon" viewBox="0 0 48 48" fill="none" aria-hidden="true">
                                        <rect x="17" y="3" width="17" height="22" rx="3" stroke="currentColor" stroke-width="2" />
                                        <path d="M21 8h9M21 12h9M21 16h6" stroke="currentColor" stroke-width="2" />
                                        <path d="m12 25 6-6m18 6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                        <path d="m8 31 5-9h22l5 9v10H8V31Z" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="2" />
                                        <path d="M8 31h32" stroke="currentColor" stroke-width="2" />
                                        <rect x="17" y="26" width="14" height="3" rx="1.5" fill="currentColor" />
                                        <circle cx="24" cy="36" r="2" fill="currentColor" />
                                    </svg>
                                    <span class="pay_method_name">线上支付</span>
                                    <span class="pay_method_description">收钱吧盒子扫付款码</span>
                                </span>
                            </el-radio>
                            <el-radio label="SELF_SCAN" class="pay_method_card">
                                <span class="pay_method_card_content">
                                    <svg class="pay_method_icon" viewBox="0 0 48 48" fill="none" aria-hidden="true">
                                        <path d="M4 15a11 11 0 0 1 22 0c0 6-5 10-11 10l-6 3 1-5c-4-2-6-4-6-8Z" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="2" />
                                        <circle cx="11" cy="14" r="1.5" fill="currentColor" /><circle cx="19" cy="14" r="1.5" fill="currentColor" />
                                        <rect x="24" y="18" width="19" height="26" rx="3" fill="var(--el-fill-color-blank)" stroke="currentColor" stroke-width="2" />
                                        <path d="M28 23h4v4h-4zM35 23h4v4h-4zM28 30h4v4h-4z" stroke="currentColor" stroke-width="1.5" />
                                        <path d="M35 30h4v5h-4v-2M31 39h5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                    <span class="pay_method_name">客户自主扫码</span>
                                    <span class="pay_method_description">患者微信扫描收款码</span>
                                </span>
                            </el-radio>
                            <el-radio label="CASH" class="pay_method_card">
                                <span class="pay_method_card_content">
                                    <svg class="pay_method_icon" viewBox="0 0 48 48" fill="none" aria-hidden="true">
                                        <path d="m9 15 27-7 5 20" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                                        <rect x="4" y="16" width="36" height="23" rx="3" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="2" />
                                        <path d="M9 22h3M32 33h3M20 22l3 5 3-5M19 28h8M19 32h8M23 27v8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span class="pay_method_name">现金缴费</span>
                                    <span class="pay_method_description">患者现场现金付款</span>
                                </span>
                            </el-radio>
                        </el-radio-group>
                        <div class="pay_method_hint" role="status">{{ paymentMethodHint }}</div>
                        <div class="mini_identity_notice" v-if="manualPaymentUncertain">缴费结果尚未确认，请关闭弹窗并刷新订单、核对收款记录，勿重复收费。</div>
                    </div>
                </div>
                <!-- 订单结果：沿用收费前的信息层级，优先突出收款状态与实收金额。 -->
                <div class="pay_order_main cashier-block cashier-result-block" v-if="!isWaitPayLoading && isPayed">
                    <div class="pay_order_success flex_c_col">
                        <div class="cashier-result-heading">
                            <el-icon class="pay_order_success_icon font_green" v-if="payState === 'success'">
                                <SuccessFilled />
                            </el-icon>
                            <el-icon class="pay_order_success_icon font_orange" v-if="payState === 'pending'">
                                <WarningFilled />
                            </el-icon>
                            <el-icon class="pay_order_success_icon font_red" v-if="payState === 'failed'">
                                <CircleCloseFilled />
                            </el-icon>
                            <div class="pay_order_success_text">
                                <strong :class="{'cashier-result-status-success': payState === 'success', 'cashier-result-status-pending': payState === 'pending', 'cashier-result-status-failed': payState === 'failed'}">{{ payResultText }}</strong>
                                <span>{{ patientInfo.name || '患者' }}的药方订单收款信息</span>
                            </div>
                        </div>
                        <div class="pay_order_error_text flex_c font_14" v-if="payState !== 'success' && payErrorMsg"
                             :style="{color: payState === 'pending' ? '#e6a23c' : '#f56c6c', margin: '8px 0'}">{{ payErrorMsg }}</div>
                        <section class="cashier-result-summary" aria-label="收款结果摘要">
                            <div class="cashier-result-summary-item">
                                <span>药方单号</span>
                                <strong>{{ medicalOrder.serialNo || '--' }}</strong>
                            </div>
                            <div class="cashier-result-summary-item" v-if="successPayed">
                                <span>支付方式</span>
                                <strong>{{ payChannelText }}</strong>
                            </div>
                            <div class="cashier-result-summary-item" v-if="successPayed">
                                <span>支付时间</span>
                                <strong>{{ medicalOrder.payTime || '--' }}</strong>
                            </div>
                        </section>
                        <section class="cashier-result-fee" aria-label="收款金额">
                            <div class="cashier-result-fee-title">{{ payState === 'success' ? (payChannel === 'FREE' ? '本单金额（无需支付）' : '本次实收金额') : '订单金额' }}</div>
                            <div class="cashier-result-total" :class="{'cashier-result-status-pending': payState === 'pending', 'cashier-result-status-failed': payState === 'failed', 'cashier-result-status-free': payChannel === 'FREE'}">￥{{ formatCashierAmount(medicalOrder.orderPrice) }}</div>
                            <div class="cashier-result-fee-detail">
                                <span>医生诊金 ￥{{ formatCashierAmount(medicalOrder.docPrice) }}</span>
                                <span>加工费用 ￥{{ formatCashierAmount(medicalOrder.processingCosts) }}</span>
                            </div>
                        </section>
                        <div class="pay_warning_info flex_t_col">
                            <div class="pay_warning_li" v-if="payDialogLocked">正在查询支付结果，请勿关闭弹窗。</div>
                            <div class="pay_warning_li" v-if="payState === 'pending'">支付结果尚未确认，请勿重复扫码，点击“重新查询”确认结果。</div>
                            <div class="pay_warning_li" v-else-if="payState === 'failed'">支付未完成，请点击“刷新重试”，重新核对支付方式后缴费。</div>
                            <div class="pay_warning_li" v-if="payState === 'success' && canPrintSqbReceipt">收款已登记，可按需预览或打印门诊收款凭证。</div>
                            <div class="pay_warning_li" v-else-if="payState === 'success' && payChannel === 'FREE'">本单无需收款，请勿按已收款订单打印凭证。</div>
                            <div class="pay_warning_li" v-if="payState === 'success' && payChannel !== 'FREE'">患者可打开“知夏中医健康平台”小程序查询订单支付结果。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="success" v-if="!isPayed" :loading="payRequesting" :disabled="isWaitPayLoading || manualPaymentUncertain || receiptLoading || (needsIdentityBinding && !miniIdentitySaved) || miniIdentitySaving || miniIdentityLoading" @click="confirmOrderPayment">确定缴费</el-button>
                <el-button type="warning" :loading="querying" v-if="isPayed && payState === 'pending'" @click="requeryPayResult()">重新查询</el-button>
                <el-button type="danger" v-if="isPayed && payState === 'failed'" @click="cancalOrRefreshPay()">刷新重试</el-button>
                <el-button :loading="receiptLoading" v-if="canPrintSqbReceipt" @click="previewPaymentReceipt">预览凭证</el-button>
                <el-button type="success" :loading="receiptLoading || receiptChecking" v-if="canPrintSqbReceipt || !medicalOrder.payTime" @click="printPaymentReceipt">打印凭证</el-button>
<!--                <el-button type="primary" v-if="!isPayed" @click="printPayInfo()">打印单据</el-button>-->
                <el-button type="info" :disabled="miniIdentitySaving || payDialogLocked || receiptLoading" @click="cancalPay()">取消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog v-model="receiptPreviewVisible" title="门诊收款凭证预览" width="440px" align-center>
        <div class="payment-receipt-print receipt-preview-content">
            <div class="receipt-title">{{ receiptInstitutionName(paymentReceipt.institutionName) }}</div>
            <div class="receipt-name">门诊收款凭证</div>
            <div class="receipt-subtitle">PATIENT PAYMENT RECEIPT</div>
            <div class="receipt-section">
                <div class="receipt-section-title">患者信息</div>
                <div class="receipt-row"><span>患者姓名</span><span>{{ displayReceiptValue(paymentReceipt.patientName) }}</span></div>
                <div class="receipt-row"><span>年龄</span><span>{{ formatReceiptAge(paymentReceipt.patientAge) }}</span></div>
                <div class="receipt-row"><span>性别</span><span>{{ formatReceiptGender(paymentReceipt.patientGender) }}</span></div>
            </div>
            <div class="receipt-section">
                <div class="receipt-section-title">处方摘要</div>
                <div class="receipt-row"><span>处方类型</span><span>{{ formatReceiptPrescriptionType(paymentReceipt.prescriptionType) }}</span></div>
                <div class="receipt-row"><span>剂数</span><span>{{ displayReceiptValue(paymentReceipt.doseCount) }}</span></div>
            </div>
            <div class="receipt-section-title receipt-payment-title">支付信息</div>
            <div class="receipt-amount"><span>实收金额</span><strong>{{ formatReceiptAmount(paymentReceipt.receivedAmount) }}</strong></div>
            <div class="receipt-section">
                <div class="receipt-row"><span>订单号</span><span>{{ displayReceiptValue(paymentReceipt.orderNo) }}</span></div>
                <div class="receipt-row"><span>支付时间</span><span>{{ displayReceiptValue(paymentReceipt.paidAt) }}</span></div>
                <div class="receipt-row"><span>支付方式</span><span>{{ formatReceiptPaymentMethod(paymentReceipt.paymentMethod) }}</span></div>
            </div>
            <div class="receipt-promotion-section" v-if="hasReceiptPromotion()">
                <div class="receipt-promotion-list">
                    <div>
                        <img :src="receiptOfficialAccountQrCode()" @error="handleReceiptPromotionImageError('officialAccount')" alt="知夏集团公众号二维码">
                        <div>打开微信扫一扫，关注【知夏集团】公众号</div>
                    </div>
                </div>
            </div>
            <div class="receipt-section receipt-print-time"><div class="receipt-row"><span>打印时间</span><span>{{ receiptPrintTime }}</span></div></div>
            <div class="receipt-footer">请妥善保管本凭条<br><small>本凭条仅作本次付款核对使用</small></div>
        </div>
        <template #footer>
            <el-button @click="receiptPreviewVisible = false">关闭</el-button>
        </template>
    </el-dialog>

    <div id="paymentReceiptPrintArea" ref="paymentReceiptPrintArea" class="payment-receipt-print">
        <div class="receipt-title">{{ receiptInstitutionName(paymentReceipt.institutionName) }}</div>
        <div class="receipt-name">门诊收款凭证</div>
        <div class="receipt-subtitle">PATIENT PAYMENT RECEIPT</div>
        <div class="receipt-section">
            <div class="receipt-section-title">患者信息</div>
            <div class="receipt-row"><span>患者姓名</span><span>{{ displayReceiptValue(paymentReceipt.patientName) }}</span></div>
            <div class="receipt-row"><span>年龄</span><span>{{ formatReceiptAge(paymentReceipt.patientAge) }}</span></div>
            <div class="receipt-row"><span>性别</span><span>{{ formatReceiptGender(paymentReceipt.patientGender) }}</span></div>
        </div>
        <div class="receipt-section">
            <div class="receipt-section-title">处方摘要</div>
            <div class="receipt-row"><span>处方类型</span><span>{{ formatReceiptPrescriptionType(paymentReceipt.prescriptionType) }}</span></div>
            <div class="receipt-row"><span>剂数</span><span>{{ displayReceiptValue(paymentReceipt.doseCount) }}</span></div>
        </div>
        <div class="receipt-section-title receipt-payment-title">支付信息</div>
        <div class="receipt-amount"><span>实收金额</span><strong>{{ formatReceiptAmount(paymentReceipt.receivedAmount) }}</strong></div>
        <div class="receipt-section">
            <div class="receipt-row"><span>订单号</span><span>{{ displayReceiptValue(paymentReceipt.orderNo) }}</span></div>
            <div class="receipt-row"><span>支付时间</span><span>{{ displayReceiptValue(paymentReceipt.paidAt) }}</span></div>
            <div class="receipt-row"><span>支付方式</span><span>{{ formatReceiptPaymentMethod(paymentReceipt.paymentMethod) }}</span></div>
        </div>
        <div class="receipt-promotion-section" v-if="hasReceiptPromotion()">
            <div class="receipt-promotion-list">
                <div>
                    <img :src="receiptOfficialAccountQrCode()" @error="handleReceiptPromotionImageError('officialAccount')" alt="知夏集团公众号二维码">
                    <div>打开微信扫一扫，关注【知夏集团】公众号</div>
                </div>
            </div>
        </div>
        <div class="receipt-section receipt-print-time"><div class="receipt-row"><span>打印时间</span><span>{{ receiptPrintTime }}</span></div></div>
        <div class="receipt-footer">请妥善保管本凭条<br><small>本凭条仅作本次付款核对使用</small></div>
    </div>
    <el-button ref="paymentReceiptPrintButton" class="receipt-print-trigger" v-print="receiptPrintInfoObj">打印门诊收款凭证</el-button>

</template>

<script>
import orderdetail from "@/assets/scripts/components/orderdetail";
import PrescriptionGroupNotice from "@/components/PrescriptionGroupNotice.vue";
import {View, Printer, Wallet} from '@element-plus/icons-vue';

export default {
    ...orderdetail,
    name: 'OrderDetail',
    components: {...orderdetail.components, PrescriptionGroupNotice, View, Printer, Wallet}
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";

@media screen { .payment-receipt-print, .receipt-print-trigger { display: none; } }
@media print { .payment-receipt-print { display: block !important; } }
.receipt-preview-content { display: block !important; margin: 0 auto; }
.payment-receipt-print { box-sizing: border-box; width: 72mm; padding: 3mm 2.5mm; color: #111; font-family: "Microsoft YaHei", SimSun, sans-serif; font-size: 10pt; line-height: 1.5; }
.receipt-title, .receipt-name, .receipt-subtitle, .receipt-footer, .receipt-barcode-section, .receipt-promotion-title { text-align: center; }
.receipt-title { font-size: 13pt; font-weight: bold; line-height: 1.4; }
.receipt-name { margin-top: 1mm; font-size: 15pt; font-weight: bold; }
.receipt-subtitle { margin: .5mm 0 2mm; padding-bottom: 2mm; border-bottom: 1px solid #111; color: #666; font-size: 8pt; letter-spacing: .7px; }
.receipt-section { padding: 1.8mm 0; border-bottom: 1px dashed #777; }
.receipt-section-title { margin-bottom: 1mm; font-size: 9pt; font-weight: bold; }
.receipt-payment-title { margin-top: 1.8mm; }
.receipt-row { display: flex; justify-content: space-between; gap: 4mm; min-height: 5mm; }
.receipt-row span:last-child { text-align: right; word-break: break-all; font-weight: 500; }
.receipt-amount { display: flex; justify-content: space-between; align-items: center; margin: 1.5mm 0; padding: 2mm; background: #f3f4f6; font-weight: bold; }
.receipt-amount strong { font-size: 13pt; }
.receipt-barcode-section { padding: 2mm 0; border-bottom: 1px dashed #777; font-size: 9pt; font-weight: bold; }
.receipt-barcode-section svg { display: block; width: 60mm; height: 17mm; margin: 1.5mm auto; }
.receipt-order-no { font-size: 9pt; letter-spacing: 1px; }
.receipt-hint, .receipt-footer small, .receipt-promotion-list small { color: #555; font-size: 8pt; font-weight: normal; }
.receipt-promotion-section { padding: 2mm 0; border-bottom: 1px dashed #777; text-align: center; }
.receipt-promotion-title { font-size: 9pt; font-weight: bold; }
.receipt-promotion-list { display: flex; justify-content: center; margin-top: 1.5mm; }
.receipt-promotion-list > div { width: 58mm; font-size: 9pt; font-weight: bold; white-space: nowrap; }
.receipt-promotion-list img { display: block; width: 32mm; height: 32mm; margin: 0 auto 1mm; object-fit: contain; }
.receipt-print-time { border-bottom: 1px solid #111; }
.receipt-footer { padding-top: 2mm; font-size: 9pt; }
/* 详情视觉微调：保留原区块顺序与字段列宽，仅统一字阶、留白与操作区。 */
.cashier-order-detail {
    color: var(--el-text-color-primary);
    font-size: 14px;

    .patient_info_bd {
        padding-top: 12px;
        padding-bottom: 12px;
        margin-bottom: 12px;
        border-bottom: 1px solid var(--el-border-color-lighter);
    }

    .patient_order_detail .el-icon {
        margin-right: 6px;
        font-size: 16px;
    }

    .detail_info_line {
        min-height: 32px;
    }

    .detail_font,
    .detail_font50 {
        min-height: 32px;
        line-height: 24px;
        overflow-wrap: anywhere;
    }

    .detail_font.flex_c_left {
        flex-wrap: wrap;
        row-gap: 4px;
    }

    .font_gray {
        color: var(--el-text-color-secondary);
        font-size: 13px;
    }

    .name_font,
    .no_font {
        font-size: 15px;
        font-weight: 600;
    }

    .no_num_font {
        font-size: 16px;
        font-weight: 600;
        color: var(--el-color-primary);
        overflow-wrap: anywhere;
    }

    .status_font {
        flex-shrink: 0;
        width: auto;
        font-size: 14px;
    }

    .status_font > span {
        padding: 2px 10px;
        border-radius: 4px;
        background: var(--el-fill-color-light);
        white-space: nowrap;
    }

    .med_list_li {
        border-color: var(--el-border-color-lighter);
        border-radius: 6px;
        background: var(--el-fill-color-light);
        min-height: 36px;
        height: auto;
        line-height: 22px;
        flex-wrap: wrap;
    }

    .med_li_name {
        font-weight: 500;
    }

    .patient_order_detail {
        height: auto;
        min-height: 64px;
        padding: 10px 16px;
        box-sizing: border-box;
        width: 100%;
        border-top: 1px solid var(--el-border-color-lighter);
        border-radius: 0;
        box-shadow: 0 -3px 10px rgba(0, 0, 0, 0.04);
    }

    .patient_order_detail .width100 {
        width: auto;
        flex: 1;
    }

    .patient_order_detail .detail_font_red {
        color: var(--el-color-danger-dark-2, #c45656);
        font-size: 24px;
        font-variant-numeric: tabular-nums;
    }

    .patient_order_detail .flex_c_right {
        gap: 8px;
        flex-wrap: wrap;
    }

    .patient_order_detail :deep(.el-button) {
        margin: 0;
        min-height: 34px;
        padding: 8px 12px;
        border-radius: 5px;
        font-weight: 500;
    }
}

/* 仅作用于订单收费弹窗，避免改变处方预览与打印凭证布局。 */
.cashier-payment-dialog {
    .pay_content {
        align-items: stretch;
        max-height: 70vh;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 4px;
        box-sizing: border-box;
    }

    /* 遮罩限定收费主体，保持顶部订单提醒可读，阻止穿透点击底层支付选项。 */
    .pay_screen_con,
    .pay_loading_con {
        z-index: 10;
        box-sizing: border-box;
        padding: 16px;
        border-radius: 6px;
        background: rgba(245, 247, 250, 0.92);
    }

    .cashier-wait-panel {
        box-sizing: border-box;
        width: 100%;
        max-width: 420px;
        padding: 22px 20px;
        border: 1px solid var(--el-border-color-lighter);
        border-radius: 10px;
        background: var(--el-fill-color-blank);
        box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
        text-align: center;
    }

    .cashier-wait-icon {
        font-size: 36px;
        color: var(--el-color-primary);
    }

    /* 扫码操作示意：微信付款码随手持手机从右上方靠近收钱吧扫码窗，停留后再收回。 */
    .cashier-scan-animation {
        position: relative;
        width: 220px;
        height: 156px;
        margin: 0 auto;
        overflow: hidden;
    }

    .cashier-scan-device {
        position: absolute;
        left: 63px;
        bottom: 10px;
        width: 100px;
        height: 48px;
        box-sizing: border-box;
        border: 2px solid var(--el-color-primary-light-5);
        border-radius: 12px 12px 8px 8px;
        background: var(--el-color-primary-light-9);
        box-shadow: 0 5px 0 var(--el-border-color-lighter);
    }

    .cashier-scan-device-window {
        position: absolute;
        top: 6px;
        left: 18px;
        width: 60px;
        height: 15px;
        border-radius: 5px;
        background: var(--el-color-primary-light-5);
    }

    .cashier-scan-device-name {
        position: absolute;
        bottom: 2px;
        left: 0;
        width: 100%;
        color: var(--el-text-color-regular);
        font-size: 10px;
        font-weight: 600;
        line-height: 16px;
        text-align: center;
    }

    .cashier-scan-beam {
        position: absolute;
        z-index: 2;
        left: 92px;
        top: 95px;
        width: 43px;
        height: 15px;
        border-radius: 50%;
        background: var(--el-color-primary-light-3);
        filter: blur(6px);
        opacity: 0;
        animation: cashier-scan-detect 3s ease-in-out infinite;
    }

    .cashier-phone-hand {
        position: absolute;
        z-index: 1;
        top: 6px;
        left: 126px;
        width: 94px;
        height: 82px;
        animation: cashier-phone-approach 3s ease-in-out infinite;
    }

    /* 手掌和拇指分层，明确手机被握住，而非悬浮在盒子旁。 */
    .cashier-hand {
        position: absolute;
        top: 36px;
        left: 44px;
        width: 52px;
        height: 33px;
        border-radius: 15px 0 0 15px;
        background: var(--el-color-warning-light-5);
        transform: rotate(-12deg);
    }

    .cashier-hand-thumb {
        position: absolute;
        top: 40px;
        left: 42px;
        width: 23px;
        height: 11px;
        border-radius: 8px;
        background: var(--el-color-warning-light-5);
        transform: rotate(-20deg);
    }

    .cashier-phone {
        position: absolute;
        top: 0;
        left: 0;
        width: 55px;
        height: 76px;
        box-sizing: border-box;
        padding: 5px 3px;
        border: 3px solid var(--el-text-color-primary);
        border-radius: 9px;
        background: var(--el-text-color-primary);
        box-shadow: 2px 3px 8px rgba(0, 0, 0, 0.12);
    }

    .cashier-phone-screen {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2px;
        height: 100%;
        border-radius: 3px;
        background: var(--el-fill-color-blank);
    }

    .cashier-phone-app,
    .cashier-phone-label {
        font-size: 9px;
        font-weight: 600;
        line-height: 11px;
        color: var(--el-color-success);
    }

    .cashier-phone-label {
        color: var(--el-text-color-primary);
    }

    /* 仅是条纹示意，不是真实可识别的付款码。 */
    .cashier-phone-code {
        width: 37px;
        height: 18px;
        background: repeating-linear-gradient(90deg,
            var(--el-text-color-regular) 0 2px, transparent 2px 4px,
            var(--el-text-color-regular) 4px 7px, transparent 7px 9px);
    }

    @keyframes cashier-phone-approach {
        0%, 12%, 100% { transform: translate(0, 0); }
        45%, 68% { transform: translate(-34px, 55px); }
    }

    @keyframes cashier-scan-detect {
        0%, 35%, 75%, 100% { opacity: 0; }
        48%, 63% { opacity: 0.9; }
    }

    @media (prefers-reduced-motion: reduce) {
        .cashier-phone-hand,
        .cashier-scan-beam,
        .cashier-wait-icon.is-loading {
            animation: none;
        }
        .cashier-phone-hand { transform: translate(-34px, 55px); }
    }

    .cashier-wait-title {
        margin-top: 10px;
        font-size: 18px;
        font-weight: 600;
        line-height: 26px;
        color: var(--el-text-color-primary);
    }

    .cashier-wait-description,
    .cashier-wait-note {
        margin-top: 8px;
        font-size: 13px;
        line-height: 21px;
        overflow-wrap: anywhere;
        color: var(--el-text-color-regular);
    }

    .cashier-wait-note {
        padding-top: 10px;
        border-top: 1px solid var(--el-border-color-lighter);
        color: var(--el-color-warning-dark-2);
        font-size: 12px;
    }

    .cashier-payment-notice {
        margin: 0 0 8px;
        padding: 6px 9px;
        border-radius: 5px;
        background: var(--el-color-warning-light-9);
        color: var(--el-color-warning-dark-2);
        font-size: 12px;
        line-height: 1.6;
        overflow-wrap: anywhere;
    }

    .pay_main_body {
        width: 100%;
        padding: 0;
        box-sizing: border-box;
    }

    .pay_order_main {
        width: 100%;
        min-width: 0;
        box-sizing: border-box;
    }

    /* 收费单式布局：患者摘要、费用带、支付操作按阅读顺序排列。 */
    .cashier-entry {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .cashier-entry > section:first-child {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
        gap: 8px;
    }

    .cashier-entry > section:first-child > .mini_identity_notice,
    .cashier-entry > section:first-child > .pay_info_item:last-child {
        grid-column: 1 / -1;
    }

    /* 限定患者摘要，避免覆盖费用带与支付结果的字段布局。 */
    .cashier-entry > section:first-child > .pay_info_item {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 2px;
        padding: 6px 10px;
        border-radius: 6px;
        background: var(--el-fill-color-light);
    }

    .cashier-entry > section:first-child .pay_info_item_left {
        flex: none;
        width: auto;
        font-size: 12px;
        line-height: 18px;
    }

    .cashier-entry > section:first-child .pay_info_item_right {
        flex: none;
        width: 100%;
        text-align: left;
        line-height: 24px;
    }

    .cashier-patient-summary {
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        gap: 8px 18px;
    }

    .cashier-patient-name {
        font-size: 17px;
        font-weight: 700;
        line-height: 24px;
        color: var(--el-text-color-primary);
    }

    .cashier-entry > section:first-child .mini_identity_value {
        justify-content: flex-start;
    }

    .cashier-block {
        min-width: 0;
        box-sizing: border-box;
        padding: 0;
        border: 0;
        border-radius: 0;
        background: var(--el-fill-color-blank);
    }

    .pay_info_title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        box-sizing: border-box;
        padding: 0 0 8px;
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: 600;
        color: var(--el-text-color-primary);
    }

    /* 流程提示合并至支付区标题，取消占高的独立步骤编号。 */

    .cashier-section-hint {
        margin-left: auto;
        color: var(--el-text-color-secondary);
        font-size: 12px;
        font-weight: 400;
    }

    .pay_method_section {
        grid-column: 1 / -1;
        margin-top: 0;
    }

    .cashier-fee-block {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.4fr);
        align-items: center;
        gap: 6px 18px;
        padding: 8px 12px;
        border-radius: 6px;
        background: var(--el-fill-color-light);
    }

    .cashier-fee-block > .pay_info_title {
        grid-column: 1 / -1;
        padding: 0;
        margin: 0;
    }

    .cashier-fee-block > .pay_info_item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;
        padding: 0;
    }

    .cashier-fee-block .pay_info_item_left {
        flex: none;
        font-size: 13px;
    }

    /* 明细与总额分级放大，统一行高，保持各列数字的视觉协调。 */
    .cashier-fee-block .pay_info_item_right {
        flex: none;
        text-align: left;
        font-size: 22px;
        line-height: 38px;
        font-weight: 600;
        color: var(--el-text-color-regular);
        font-variant-numeric: tabular-nums;
    }

    /* 待收总额以柔和红色强调，明细用次级深灰，避免所有金额争抢视觉焦点。 */
    .cashier-fee-block .cashier-amount-row .pay_info_item_right {
        font-size: 30px;
        line-height: 38px;
        color: var(--el-color-danger-dark-2, #c45656);
    }

    .cashier-fee-block > .cashier-amount-row {
        margin: 0;
        padding-left: 18px;
        border-left: 1px solid var(--el-border-color);
        border-radius: 0;
        background: transparent;
    }

    .cashier-entry > .cashier-block:first-child .pay_info_item_right {
        font-weight: 500;
    }

    .pay_info_item {
        box-sizing: border-box;
        padding: 7px 0;
        gap: 16px;
        min-width: 0;
        align-items: center;
    }

    .pay_info_item_left {
        flex: 0 0 84px;
        width: auto;
        font-weight: 400;
        color: var(--el-text-color-secondary);
    }

    .pay_info_item_right {
        flex: 1;
        min-width: 0;
        width: auto;
        color: var(--el-text-color-primary);
        text-align: right;
        overflow-wrap: anywhere;
        font-variant-numeric: tabular-nums;
    }

    .mini_identity_binding,
    .mini_identity_value {
        text-align: left;
    }

    .mini_identity_value {
        justify-content: flex-end;
    }

    .cashier-amount-row {
        margin-top: 8px;
        padding: 12px 14px;
        background: var(--el-color-primary-light-9);
        border-radius: 6px;
    }

    .cashier-amount-row .pay_info_item_left {
        color: var(--el-text-color-primary);
        font-weight: 600;
    }

    .cashier-amount-row .pay_info_item_right {
        color: var(--el-color-primary);
        font-size: 28px;
        line-height: 36px;
    }

    .pay_method_options :deep(.el-radio.pay_method_card) {
        min-height: 112px;
        padding: 10px 8px;
    }

    .pay_method_icon {
        width: 36px;
        height: 36px;
    }

    .pay_order_success_icon {
        font-size: 48px;
        margin: 0;
    }

    .cashier-result-heading {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        width: 100%;
        padding: 4px 0 12px;
        border-bottom: 1px solid var(--el-border-color-lighter);
    }

    .pay_order_success_text {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        height: auto;
        line-height: 22px;
        text-align: center;
    }

    .pay_order_success_text strong {
        color: var(--el-color-success);
        font-size: 20px;
        line-height: 28px;
    }

    .pay_order_success_text strong.cashier-result-status-pending {
        color: var(--el-color-warning);
    }

    .pay_order_success_text strong.cashier-result-status-failed {
        color: var(--el-color-danger);
    }

    .pay_order_success_text span {
        color: var(--el-text-color-secondary);
        font-size: 13px;
    }

    .cashier-result-summary {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        width: 100%;
        margin-top: 12px;
        padding: 10px 12px;
        box-sizing: border-box;
        border-radius: 6px;
        background: var(--el-fill-color-light);
        gap: 12px;
    }

    .cashier-result-summary-item {
        display: flex;
        flex-direction: column;
        gap: 3px;
        min-width: 0;
    }

    .cashier-result-summary-item span {
        color: var(--el-text-color-secondary);
        font-size: 12px;
        line-height: 18px;
    }

    .cashier-result-summary-item strong {
        overflow-wrap: anywhere;
        color: var(--el-text-color-primary);
        font-size: 14px;
        line-height: 20px;
    }

    .cashier-result-fee {
        width: 100%;
        margin-top: 10px;
        padding: 12px 14px;
        box-sizing: border-box;
        border-radius: 6px;
        background: var(--el-color-primary-light-9);
    }

    .cashier-result-fee-title {
        color: var(--el-text-color-primary);
        font-size: 13px;
        font-weight: 600;
    }

    .cashier-result-total {
        margin-top: 2px;
        color: var(--el-color-success);
        font-size: 30px;
        font-weight: 700;
        line-height: 40px;
        font-variant-numeric: tabular-nums;
    }

    .cashier-result-total.cashier-result-status-pending {
        color: var(--el-color-warning);
    }

    .cashier-result-total.cashier-result-status-failed,
    .cashier-result-total.cashier-result-status-free {
        color: var(--el-text-color-regular);
    }

    .cashier-result-fee-detail {
        display: flex;
        flex-wrap: wrap;
        gap: 6px 18px;
        color: var(--el-text-color-secondary);
        font-size: 12px;
        line-height: 20px;
    }

    .pay_warning_info {
        box-sizing: border-box;
        width: 100%;
        margin-top: 14px;
        padding: 10px 12px;
        border-radius: 6px;
        background: var(--el-fill-color-light);
    }

    .pay_warning_li {
        padding-left: 0;
        color: var(--el-text-color-secondary);
        font-size: 13px;
        line-height: 22px;
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 10px;
        padding-top: 12px;
        border-top: 1px solid var(--el-border-color-lighter);
    }

    .dialog-footer .el-button {
        margin: 0;
        min-width: 92px;
    }
}

@media (max-width: 560px) {
    .cashier-block {
        padding: 10px 12px;
    }

    .cashier-section-hint {
        width: auto;
        margin-left: 0;
    }

    .cashier-amount-row .pay_info_item_right {
        font-size: 24px;
    }

    .pay_method_options {
        grid-template-columns: minmax(0, 1fr);
        gap: 8px;
    }

    .pay_method_options :deep(.el-radio.pay_method_card) {
        min-height: 84px;
    }

    .cashier-payment-dialog .pay_info_item {
        gap: 8px;
    }

    .cashier-payment-dialog .mini_identity_row {
        flex-wrap: wrap;
    }

    .cashier-payment-dialog .mini_identity_binding {
        flex-basis: 100%;
    }

    .cashier-payment-dialog .cashier-result-summary {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }

    .cashier-payment-dialog .cashier-result-summary-item:last-child {
        grid-column: 1 / -1;
    }

    .cashier-payment-dialog .cashier-result-total {
        font-size: 26px;
    }
}

.pay_method_section { margin-top: 12px; }
.pay_method_options { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; width: 100%; }
.pay_method_options :deep(.el-radio.pay_method_card) { position: relative; display: flex; align-items: stretch; justify-content: center; box-sizing: border-box; width: 100%; min-width: 0; min-height: 132px; height: auto; margin: 0; padding: 12px 8px; border: 1px solid var(--el-border-color); border-radius: 6px; background: var(--el-fill-color-blank); white-space: normal; transition: border-color .15s ease, background-color .15s ease, box-shadow .15s ease; }
.pay_method_options :deep(.el-radio__input) { position: absolute; top: 9px; right: 9px; }
.pay_method_options :deep(.el-radio:focus-within) { outline: 2px solid var(--el-color-primary-light-5); outline-offset: 2px; }
.pay_method_options :deep(.el-radio__label) { display: flex; align-items: center; justify-content: center; width: 100%; min-width: 0; padding: 0; color: var(--el-text-color-primary); white-space: normal; }
.pay_method_options :deep(.el-radio.pay_method_card.is-checked) { border-color: var(--el-color-primary); background: var(--el-color-primary-light-9); box-shadow: inset 0 0 0 1px var(--el-color-primary); }
.pay_method_options :deep(.el-radio.pay_method_card.is-disabled) { cursor: not-allowed; opacity: .7; }
.pay_method_card_content { display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; min-width: 0; gap: 5px; text-align: center; line-height: 1.35; }
.pay_method_icon { display: block; width: 44px; height: 44px; flex-shrink: 0; color: var(--el-color-primary); }
.pay_method_name { font-size: 14px; font-weight: 600; overflow-wrap: anywhere; }
.pay_method_description { color: var(--el-text-color-secondary); font-size: 12px; line-height: 1.4; overflow-wrap: anywhere; }
/* 支付方式适度放大图文与点击区域，保持三列一致且不额外堆叠高度。 */
.cashier-payment-dialog .pay_method_options :deep(.el-radio.pay_method_card) {
    min-height: 100px;
    padding: 16px 22px 16px 12px;
    border-radius: 8px;
}
.cashier-payment-dialog .pay_method_options :deep(.el-radio.pay_method_card:not(.is-disabled):hover) {
    border-color: var(--el-color-primary-light-3);
    background: var(--el-color-primary-light-9);
}
.cashier-payment-dialog .pay_method_card_content {
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 6px 10px;
    align-items: center;
    text-align: left;
}
.cashier-payment-dialog .pay_method_icon {
    grid-row: 1 / 3;
    width: 36px;
    height: 36px;
}
.cashier-payment-dialog .pay_method_name {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
}
.cashier-payment-dialog .pay_method_description {
    font-size: 13px;
    line-height: 19px;
}
@media (max-width: 640px) {
    .cashier-payment-dialog .cashier-entry > section:first-child {
        grid-template-columns: minmax(0, 1fr);
    }
    .cashier-payment-dialog .pay_method_options {
        grid-template-columns: minmax(0, 1fr);
    }
    .cashier-payment-dialog .pay_method_options :deep(.el-radio.pay_method_card) {
        min-height: 54px;
    }
}
.pay_method_hint {
    white-space: normal;
    overflow-wrap: anywhere;
    margin-top: 8px;
    padding: 8px 10px;
    border-radius: 4px;
    background: var(--el-color-primary-light-9);
    color: var(--el-text-color-regular);
    font-size: 13px;
    line-height: 1.6;
}
.mini_identity_notice { padding: 10px 12px; margin-bottom: 12px; border-radius: 4px; color: var(--el-color-warning-dark-2); background: var(--el-color-warning-light-9); font-size: 13px; line-height: 1.6; }
.mini_identity_row { display: flex; flex-direction: row; flex-wrap: nowrap; align-items: flex-start; box-sizing: border-box; }
.mini_identity_row > .pay_info_item_left { flex: 0 0 80px; white-space: nowrap; line-height: 32px; }
.mini_identity_row > .pay_info_item_right { flex: 1; min-width: 0; width: auto; }
.mini_identity_row_bound { align-items: center; }
.mini_identity_row_bound > .pay_info_item_left { line-height: 24px; }
.mini_identity_value { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 10px; }
.mini_identity_value > span:first-child { white-space: nowrap; }
.mini_identity_success { display: inline-flex; align-items: center; padding: 0 6px; border-radius: 4px; color: var(--el-color-success); background: var(--el-color-success-light-9); font-size: 12px; line-height: 24px; }
.mini_identity_binding { position: relative; }
.mini_identity_controls { display: flex; align-items: center; gap: 8px; }
.mini_identity_select { flex: 1; min-width: 0; }
.mini_identity_hint { margin-top: 6px; color: var(--el-text-color-secondary); font-size: 12px; line-height: 1.6; }
/* 身份核对标题独占一行，避免完整核验提示挤占下拉框和号码列。 */
.cashier-payment-dialog .mini_identity_row {
    flex-wrap: wrap;
}
.cashier-payment-dialog .mini_identity_row > .pay_info_item_left {
    flex: 0 0 100%;
    width: 100%;
    white-space: normal;
    margin-bottom: 6px;
}
.mini_identity_consistent {
    color: var(--el-color-success);
    font-size: 12px;
    font-weight: normal;
}
.mini_phone_hint {
    color: var(--el-text-color-secondary);
    font-size: 12px;
    font-weight: normal;
}
.mini_identity_comparison {
    margin-top: 10px;
    padding: 10px 12px;
    border: 1px solid var(--el-border-color-light);
    border-radius: 4px;
    background: var(--el-fill-color-light);
}
.mini_identity_comparison_row {
    display: grid;
    grid-template-columns: 90px minmax(0, 1fr) 180px;
    gap: 8px;
    padding: 6px 0;
    text-align: left;
    font-size: 12px;
    line-height: 1.6;
}
.mini_identity_comparison_row strong {
    font-variant-numeric: tabular-nums;
    overflow-wrap: anywhere;
}
.mini_identity_invalid {
    color: var(--el-color-danger);
}
.mini_identity_selected {
    color: var(--el-color-primary);
    border-top: 1px solid var(--el-border-color-light);
}
</style>
